import useCache from "../../hooks/use-cache";
import { useGetContentQuery } from "../../store";
import parse from 'html-react-parser';

export default function AboutUs() {

    const pageKey = 'footer';
    const { data } = useCache(pageKey, useGetContentQuery, pageKey);

    const content = data && data.length && data[0].content;
    if (!content) { return; }

    const body = parse(content.body);

    return (
        <div className="footer-item">
            <span className="title-h2 title-underscore">{content.title}</span>
            <div className="footer-text">{body}</div>
        </div>
    )
}